"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConsoleLoggingService = console;
exports.ConsoleLoggingService = ConsoleLoggingService;
